// Resolve which site a page should open on.
//
// Pages remember the last site the user picked (state.sites.selectedSite), but
// that id can go stale — the site may have been deleted, or the user may have
// lost access to it. Fall back to the first site they can actually see rather
// than leaving the page pointed at something that no longer resolves.
export const resolveSelectedSite = (remembered, sites) => {
  const list = Array.isArray(sites) ? sites : [];

  if (
    remembered &&
    list.some(site => String(site._id) === String(remembered))
  ) {
    return remembered;
  }

  return list[0] ? list[0]._id : null;
};
